/**
 * Met à jour le titre de l'onglet navigateur : « (nom du volet) - Cavorama.fr ».
 * Rendu une seule fois sous <BrowserRouter>, il réagit à chaque changement de route.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SUFFIX = 'Cavorama.fr';

/** Résout le nom du volet à partir du chemin (ordre : du plus spécifique au plus général). */
function voletFor(pathname) {
  const p = pathname || '/';
  if (p === '/') return 'Tableau de bord';
  if (p.startsWith('/scanner')) return 'Scanner';
  if (p.startsWith('/sortie')) return 'Sortie';
  if (p.startsWith('/cave/degustes')) return 'Vins dégustés';
  if (p.startsWith('/cave')) return 'La cave';
  if (p.startsWith('/achats')) return 'Achats';
  if (p.startsWith('/piloter')) return 'Piloter';
  if (p.startsWith('/carte')) return 'Carte des vins';
  if (p.startsWith('/vignobles/decouvrir')) return 'À découvrir';
  if (p.startsWith('/vignobles')) return 'Vignobles';
  if (p.startsWith('/parametres')) return 'Paramètres';
  if (p.startsWith('/admin')) return 'Super Admin';
  if (p.startsWith('/login')) return 'Connexion';
  if (p.startsWith('/reset-password')) return 'Mot de passe';
  if (p.startsWith('/impersonate')) return 'Connexion';
  if (p.startsWith('/c/')) return 'Carte des vins';
  return null;
}

export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const volet = voletFor(pathname);
    document.title = volet ? `${volet} - ${SUFFIX}` : SUFFIX;
  }, [pathname]);
  return null;
}
